import type { NavigationCounts } from '@risksmart-app/trpc/src/types';
import type {
  GetTestResultCountQuery,
  Test_Result_Bool_Exp,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetTestResultCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

import type { NavigationCountArgs } from '../navigation/navigationCounts';
import {
  navigationCountsQueryOptions,
  toAggregate,
} from '../navigation/navigationCounts';

type TestResultCountArgs = NavigationCountArgs & {
  // The equivalent Hasura bool_exp (incl. the RatingType predicate) — drives
  // the GraphQL fallback so the flag-gated twin counts identically. Built by
  // useEntityWhereFilter.
  where?: Test_Result_Bool_Exp;
};

export const useGetTestResultCount = createQueryHook<
  TestResultCountArgs,
  NavigationCounts,
  GetTestResultCountQuery
>({
  trpcQueryOptions: navigationCountsQueryOptions,
  mapTrpcDataToGraphQL: (data) => ({
    test_result_aggregate: { aggregate: toAggregate(data.testResult) },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetTestResultCountDocument,
  graphqlVariables: (queryArgs) => ({ where: queryArgs?.where }),
});
